import React from "react";
import { Link } from "react-router-dom";
import TopicOne from "../stock-market-contents/TopicOne";

const StockMarketContentOne = () => {
  return (
    <>
      {/* Add the TopicOne component here */}
      <TopicOne />

      <div className="how__work__market">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h3>Global Market Access</h3>
                <p>
                  Trade shares from major exchanges like NASDAQ, NYSE, and LSE
                  with full transparency.
                </p>
                <h3>No Ownership Hassles</h3>
                <p>
                  Trade stock CFDs and speculate on price movements without
                  holding the actual shares.
                </p>
                <h3>Advanced Analytics</h3>
                <p>
                  Use cutting-edge charting tools and market data to make
                  informed trading decisions.
                </p>
                <h3>Seamless Execution</h3>
                <p>
                  Experience ultra-fast execution and minimal slippage, even in
                  volatile conditions.
                </p>
                {/* <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Register now
                </Link> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/stocks_cfd/stocks_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StockMarketContentOne;
